import { get, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROPicklist = get('reservation.ROPicklist');

export const getAll = createSelector(getROPicklist, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getOrderedPending = createSelector(
  getAllValues,
  orderBy('id', 'desc')
);

export const getOrder = createSelector(getROPicklist, get('order'));

export const getIsFetching = createSelector(getROPicklist, get('fetching'));
export const getIsFetched = createSelector(getROPicklist, get('fetched'));

export const getFetchingError = createSelector(
  getROPicklist,
  get('fetchingError')
);

export const getIsSaving = createSelector(getROPicklist, get('saving'));

export const getIsSaved = createSelector(getROPicklist, get('saved'));

export const getIsDeleting = createSelector(getROPicklist, get('deleting'));

export const getIsDeleted = createSelector(getROPicklist, get('deleted'));

export const getDeletingError = createSelector(
  getROPicklist,
  get('deletingError')
);
